import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RunModalComponent } from './run-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';



@NgModule({
  declarations: [
    RunModalComponent
  ],
  imports: [
    CommonModule, SharedModule, ReactiveFormsModule
  ]
})
export class RunModalModule { }
